module.exports = __webpack_public_path__ + "img/logo-date_pre.eec5260d.svg";